<template>
  <nav class="main-nav">
    <router-link to="#about">About</router-link>
    <router-link to="#services">Services</router-link>
    <router-link to="#research">Research</router-link>
    <router-link to="#testimonials">Testimonials</router-link>
    <router-link to="#contact">Contact</router-link>
  </nav>
</template>

<script>
export default {
  name: 'Navigation'
}
</script>

<style scoped>
.main-nav {
  background-color: #2c3e50;
  padding: 15px 0;
  text-align: center;
}

.main-nav a {
  color: white;
  text-decoration: none;
  margin: 0 15px;
  padding: 5px 10px;
  transition: color 0.3s;
}

.main-nav a:hover {
  color: #42b983;
}

.main-nav a.router-link-active {
  color: #42b983;
  border-bottom: 2px solid #42b983;
}
</style>
